import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOrTiny,
  mediaWideNavless,
} from '@xing-com/layout-tokens';
import {
  SkeletonBodyCopy,
  SkeletonButton,
  SkeletonPillShape,
} from '@xing-com/skeleton';
import {
  scale150,
  scale280,
  scale320,
  spaceXS,
  spaceM,
  spaceL,
  spaceXXL,
  space3XL,
} from '@xing-com/tokens';

const RequestSentContainerSkeleton = styled.div`
  padding: ${space3XL} 0;

  @media ${mediaConfined} {
    padding: ${space3XL} ${spaceXXL};
  }

  @media ${mediaWideNavless} {
    padding: ${spaceXXL} ${space3XL};
  }
`;

const RequestSentContactContainerSkeleton = styled.div`
  display: flex;
  gap: ${spaceL};
  margin-bottom: ${space3XL};
`;

const RequestSentContactCopiesContainerSkeleton = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

type RequestReceivedContactBodyCopySkeletonProps = {
  width?: string;
};

const RequestSentContactBodyCopySkeleton = styled(
  SkeletonBodyCopy
)<RequestReceivedContactBodyCopySkeletonProps>`
  display: block;
  padding: ${spaceXS} 0;

  &:not(:last-child) {
    margin-bottom: ${spaceL};
  }

  ${(props) =>
    props.width
      ? `
      max-width: ${props.width}
  `
      : `
      max-width: ${scale320};
  `}
`;

const RequestSentContactButtonsContainerSkeleton = styled.div`
  display: flex;
  flex: 0.75;
  gap: ${spaceM};
`;

const RequestSentContactAcceptButtonSkeleton = styled(SkeletonButton)`
  max-width: ${scale280};

  @media ${mediaSmallOrTiny} {
    height: ${scale150};
    max-width: ${scale150};
  }
`;

const RequestSentContactSkeletonPillShapeSkeleton = styled(SkeletonPillShape)`
  margin-top: ${spaceM};
`;

export const Styled = {
  RequestSentContainerSkeleton,
  RequestSentContactContainerSkeleton,
  RequestSentContactCopiesContainerSkeleton,
  RequestSentContactBodyCopySkeleton,
  RequestSentContactButtonsContainerSkeleton,
  RequestSentContactAcceptButtonSkeleton,
  RequestSentContactSkeletonPillShapeSkeleton,
};
